// https://dribbble.com/shots/20267926-Core-Dashboard-Builder-Customer-Components
import React from "react";
import usePropertySearch from "@/hooks/usePropertySearch";

import Icon from "@ide/shared/components/Icon";

const SearchInputButton = ({
  onClick = () => {},
  placeholder = "Search area or project",
  showFilterButton = true,
  onFilterClick = () => {},
}) => {
  const { filtersCount, values, searchParams } = usePropertySearch();

  const label = React.useMemo(() => {
    if (searchParams.search_by_map) {
      return "Map area";
    }

    if (values._areasOrProjects) {
      return values._areasOrProjects;
    }

    return placeholder;
  }, [values, searchParams]);

  return (
    <div className="w-full h-full relative flex items-center gap-3">
      <button
        className="flex flex-1 justify-center items-center flex-nowrap gap-2 h-full px-2 overflow-hidden rounded-full bg-neutral-100 outline-hidden"
        onClick={onClick}
      >
        <Icon icon="fa-solid fa-magnifying-glass" className="pointer-events-none" />
        <span className="text-gray-500 text-sm text-nowrap text-ellipsis">{label}</span>
      </button>

      {showFilterButton && (
        <button
          onClick={onFilterClick}
          className="outline-hidden relative h-4/5 aspect-square flex justify-center items-center bg-white shadow-lg rounded-full border border-neutral-400"
        >
          <Icon icon="fa-solid fa-sliders" className="w-3" />
          {filtersCount > 0 && (
            <div className="flex justify-center items-center w-5 h-5 absolute right-0 top-0 translate-x-2/5 -translate-y-2/5 bg-black rounded-full">
              <span className="text-white text-xs font-medium">{filtersCount}</span>
            </div>
          )}
        </button>
      )}
    </div>
  );
};

export default SearchInputButton;
